













































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import axios from 'axios'

interface QuotesDataEntryInterface {
  id: number;
  quoteText: string;
  channel: string;
}

@Component({
  name: 'channel-detail-quotes'
})
export default class ChannelQuotes extends Vue {
  isLoaded = false
  quotes: QuotesDataEntryInterface[] = []

  get hasData () {
    return (
      this.quotes.length > 0
    )
  }

  mounted () {
    const channel = this.$route.params.channel

    axios.get(`/api/c/${channel}/quotes`).then(response => {
      this.quotes = response.data
      this.isLoaded = true
    })
  }
}
